import { render, staticRenderFns } from "./ExpertProjectBlock.vue?vue&type=template&id=383150f8&"
import script from "./ExpertProjectBlock.vue?vue&type=script&lang=js&"
export * from "./ExpertProjectBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports